'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _instafeed = require('instafeed.js');

var _instafeed2 = _interopRequireDefault(_instafeed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstafeedComponent = function (_Component) {
  _inherits(InstafeedComponent, _Component);

  function InstafeedComponent() {
    _classCallCheck(this, InstafeedComponent);

    return _possibleConstructorReturn(this, (InstafeedComponent.__proto__ || Object.getPrototypeOf(InstafeedComponent)).apply(this, arguments));
  }

  _createClass(InstafeedComponent, [{
    key: 'render',
    value: function render() {
      var instafeed = new _instafeed2.default({
        target: this.props.target || 'instafeed',
        get: 'user',
        userId: this.props.userId,
        clientId: this.props.clientId,
        accessToken: this.props.accessToken,
        resolution: this.props.resolution || 'standard_resolution',
        sortBy: this.props.sortBy || 'most-recent',
        limit: this.props.limit || 10,
        filter: function filter(item) {
          return item.caption && item.caption.text ? (item.short_caption = item.caption.text, item.short_caption.length > 160 && (item.short_caption = item.caption.text.slice(0, 150) + '...'), item.short_caption = item.short_caption.replace(/(#[a-zA-Z0-9_-]+)/g, '<strong class=\'instafeed__item__hashtag\'>$1</strong>')) : item.short_caption = '', !0 // eslint-disable-line no-sequences
          ;
        },
        template: this.props.template || '\n            <a href=\'{{link}}\' target=\'_blank\' class=\'instafeed__item\'>\n              <img class=\'instafeed__item__background\' src=\'{{image}}\' />\n                <div class=\'instafeed__item__overlay\'>\n                  <div class=\'instafeed__item__overlay--inner\'>\n                    <p class=\'instafeed__item__caption\'>{{model.short_caption}}</p>\n                    <p class=\'instafeed__item__location\'>{{location}}</p>\n                  </div>\n                </div>\n            </a>'
      });
      instafeed.run();

      return _react2.default.createElement('div', { id: instafeed.target });
    }
  }]);

  return InstafeedComponent;
}(_react.Component);

InstafeedComponent.propTypes = {
  userId: _propTypes.string,
  clientId: _propTypes.string,
  accessToken: _propTypes.string,
  target: _propTypes.string,
  resolution: _propTypes.string,
  limit: _propTypes.string,
  template: _propTypes.string
};

exports.default = InstafeedComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instafeed/dist/index.js
// module id = 172
// module chunks = 0